"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

var Circle =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Circle, _PureComponent);

  function Circle() {
    (0, _classCallCheck2["default"])(this, Circle);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Circle).apply(this, arguments));
  }

  (0, _createClass2["default"])(Circle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          className = _this$props.className,
          color = _this$props.color,
          outline = _this$props.outline,
          outlineWidth = _this$props.outlineWidth;
      return _react["default"].createElement("svg", {
        className: className,
        fill: color,
        stroke: outline,
        strokeWidth: outlineWidth,
        width: width,
        height: width,
        viewBox: "0 0 18 18"
      }, _react["default"].createElement("circle", {
        cx: "9",
        cy: "9",
        r: "8"
      }));
    }
  }]);
  return Circle;
}(_react.PureComponent);

exports["default"] = Circle;
Circle.propTypes = {
  color: _propTypes["default"].string,
  className: _propTypes["default"].string,
  outline: _propTypes["default"].string,
  width: _propTypes["default"].number,
  outlineWidth: _propTypes["default"].string
};
Circle.defaultProps = {
  color: '',
  outline: _colors.alloy,
  className: 'default',
  width: 14,
  outlineWidth: '1px'
};